import config from '../../config';

export const isAnalytixLive = (): boolean => {
  return config.app.customer_name === 'AnalytixLive';
};

export const isPremise = (): boolean => {
  return config.app.customer_name !== 'PushMetrics'; // default name (our name)
}
